import axios from "axios";
import { BACKEND_URL } from "../utils/constant";

const API_URL = `${BACKEND_URL}api/prestige-cards`;

const prestigeCardService = {
    getPrestigeCards: async (token, limit = 10, offset = 0, search = "", startDate = "", endDate = "") => {
        const response = await axios.get(`${API_URL}?limit=${limit}&offset=${offset}&search=${search}&startDate=${startDate}&endDate=${endDate}`, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data;
    },

    getAllPrestigeCardsData: async (token, search = "", startDate = "", endDate = "") => {
        const response = await axios.get(`${API_URL}?search=${search}&startDate=${startDate}&endDate=${endDate}`, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data;
    },

    getPrestigeCard: async (token, id) => {
        const response = await axios.get(`${API_URL}/${id}`, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data;
    },

    postPrestigeCard: async (token, body) => {
        const response = await axios.post(API_URL, body, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data;
    },

    updatePrestigeCard: async (token, id, body) => {
        const response = await axios.put(`${API_URL}/${id}`, body, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data;
    },

    deletePrestigeCard: async (token, id) => {
        const response = await axios.delete(`${API_URL}/${id}`, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data;
    },

    bulkDeletePrestigeCards: async (token, ids, selectAll = false, search = "", startDate = "", endDate = "") => {
        const response = await axios.delete(`${API_URL}/bulk`, {
            data: { ids, selectAll, search, startDate, endDate },
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data;
    },

    bulkPostPrestigeCards: async (token, cards) => {
        const response = await axios.post(`${API_URL}/bulk`, cards, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data;
    },
};

export default prestigeCardService;
